import { render } from "./CounterProduct.vue?vue&type=template&id=f9228062&scoped=true"
import script from "./CounterProduct.vue?vue&type=script&lang=js"
export * from "./CounterProduct.vue?vue&type=script&lang=js"

import "./CounterProduct.vue?vue&type=style&index=0&id=f9228062&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9228062"]])

export default __exports__